import React from 'react';
import Main from "./pages/main/main";
import ServerException from "./pages/server/exception";
import {Switch, Route, BrowserRouter, Redirect} from 'react-router-dom';
import Fbalance from "./pages/server/fbalance";
import StartPage from "./pages/landing/start";
import NotFound from "./pages/server/notfound";
import navigation from "./pages/main/sidebar/navigation";
import * as consts from "./store/constants/sidebar";
import {sidebarActions} from "./store/actions/sidebarActions";
import {connect} from "react-redux";
import * as Sentry from "@sentry/react";

const myFallback = <ServerException />;
class App extends React.Component {

  componentDidMount() {
    this.props.fetchData(navigation, this, consts.SIDEBAR);
  }

  render() {
    const prefix = process.env.PUBLIC_URL
    if (this.props.data.items) {
      return (
        <Sentry.ErrorBoundary fallback={myFallback}>
          <BrowserRouter>
            <Switch>
              <Route exact path={`${prefix}/`} >
                <Redirect to={`${prefix}/page/home`} />
              </Route>
              <Route path={`${prefix}/page/:id`} render={(props) => {
                const id = props.match.params.id;
                const data = this.props.data.items.find(item => item.value === id);
                if (data) {
                  return <Main {...props} {...data} />
                }
                return <NotFound/>
              }}/>
              <Route path={`${prefix}/error`} component={ServerException}/>
              <Route path={`${prefix}/ib`} component={Fbalance}/>
              <Route path={`${prefix}/start/:bank`} render={(props) => {
                const bank = props.match.params.bank;
                if (bank) {
                  return <StartPage {...props} {...bank} />
                }
                return <NotFound/>
              }}/>
              <Route path={`${prefix}/*`} exact={true} component={NotFound}/>
            </Switch>
          </BrowserRouter>
        </Sentry.ErrorBoundary>
      )
    }
    else {
      return <div>Грузим</div>
    }
  }
}

const mapStateToProps = state => ({data: state.sidebarNav});

const mapDispatchToProps = dispatch => {
  return {fetchData: (data, parent, types) => dispatch(sidebarActions(data, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(App);